import AxiosClient from './api'
import END_POINT from './constants'

export function getPlan() {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.CHANGE_PLAN.GET_PLAN}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function upgradeToTeamPlan(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.CHANGE_PLAN.TO_TEAM_PLAN}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function upgradeToEnterprise(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.CHANGE_PLAN.TO_ENTERPRISE}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function upgradeToBasic() {
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.CHANGE_PLAN.TO_BASIC}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
